// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCBdIeW8KJV0qV2XoPGT0lfukBQLzpw96k",
  authDomain: "referral-ico.firebaseapp.com",
  projectId: "referral-ico",
  storageBucket: "referral-ico.firebasestorage.app",
  messagingSenderId: "682632979601",
  appId: "1:682632979601:web:bb7ceba655013b51b34b30",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
